if (!customElements.get('gbc-contact')) {
  customElements.define('gbc-contact', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced === 'true') return;
      const inquiry = this.querySelector('[data-contact-inquiry]');
      const service = this.querySelector('[data-contact-service]');
      const help = this.querySelector('[data-contact-message-help]');
      const state = this.querySelector('[data-contact-state]');
      if (!inquiry || !service || !help || !state) return;
      this.dataset.enhanced = 'true';
      const inquiryValues = new Set(['order', 'buyback', 'donation', 'other']);
      const serviceValues = new Set(['school-buybacks', 'athletic-departments', 'k-12-schools', 'libraries', 'book-stores', 'other']);
      const query = new URLSearchParams(window.location.search);
      // Never insert arbitrary URL content as HTML or overwrite a submitted form.
      if (state.dataset.hasResponse !== 'true' && !inquiry.value) {
        const requestedInquiry = query.get('inquiry');
        if (inquiryValues.has(requestedInquiry)) inquiry.value = requestedInquiry;
        const requestedService = query.get('service');
        if (inquiry.value === 'buyback' && serviceValues.has(requestedService)) service.value = requestedService;
      }
      const helpText = {
        order: 'For an existing order, include your order number. For a shopping question, include the title, ISBN, or a link to the listing.',
        buyback: 'Include ISBNs, editions, quantities, and condition notes. If your list is not ready, describe the inventory and what you would like reviewed.',
        donation: 'Describe the kinds of books, their condition, your Northwest Arkansas location, and any access restrictions for a possible pickup.',
        other: 'Tell us what you need help with. Please do not include payment-card details.',
        default: 'For a shopping question, include a title, ISBN, or listing link. For books to sell or donate, describe the books and their condition.'
      };
      const update = () => {
        for (const group of this.querySelectorAll('[data-contact-group]')) {
          const visible = group.dataset.contactGroup.split(' ').includes(inquiry.value);
          group.hidden = !visible;
          group.disabled = !visible;
        }
        for (const note of this.querySelectorAll('[data-contact-note]')) note.hidden = note.dataset.contactNote !== inquiry.value;
        help.textContent = helpText[inquiry.value] || helpText.default;
      };
      inquiry.addEventListener('change', update);
      update();
      // Success and error handling comes only from Shopify's server response.
      const result = this.querySelector('[data-contact-result]');
      if (result) result.focus();
    }
  });
}
